<nz-modal nzClassName="inactive-tag-exists-modal" [nzVisible]="isOpen" [nzFooter]="null" [nzWidth]="width" [nzStyle]="{ top: '20px' }" [nzMask]="false" (nzOnCancel)="handleCancel()">
  <ng-template nzModalContent>
    <div class="d-flex flex-d-c align-items-c pl-38px pr-38px pt-20px pb-20px">
      <img src="/dist/img/tags/tag-circle.svg" alt="tag-circle" />
      <h4 class="mt-20px">{{ "tag_exists_title" | localize }}</h4>
      <p class="t-align-c">{{ "existing_tag_is_deactivated_cta" | localize }}</p>
      <div class="mt-16px d-flex justify-cont-c">
        <button gh-button class="gh-b gh-accent large primary" size="large" kind="primary" data-test-id="activate-tag-modal-button" (click)="handleActivate()">
          {{ "activate" | localize }}
        </button>
        <button gh-button class="gh-b large secondary" size="large" kind="secondary" data-test-id="cancel-modal-button" (click)="handleCancel()">
          {{ "cancel" | localize }}
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>
